import React from 'react';
import './Loading.css';

function Loading() {
  return (
    <div className="loading-overlay">
      <div className="loading-content">
        <div className="spinner"></div>
        <div className="loading-text">Please Wait...</div>
      </div>
    </div>
  );
}

export default Loading;
